import { BATCHING_SIZE_RESET_TIME } from "~/utils/constants";

export class BatchSizeProvider {
  private sizeIndex = 0;
  private timeoutHandle: null | ReturnType<typeof window.setTimeout> = null;
  constructor(private batchSizes: number[]) {}

  getBatchSize() {
    const size = this.batchSizes[this.sizeIndex];
    this.sizeIndex = Math.min(this.sizeIndex + 1, this.batchSizes.length - 1);

    if (this.timeoutHandle) {
      clearTimeout(this.timeoutHandle);
    }
    this.timeoutHandle = window.setTimeout(() => (this.sizeIndex = 0), BATCHING_SIZE_RESET_TIME);
    return size;
  }
}
